import { Component, Input } from '@angular/core';

@Component({
  selector: 'eh-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input()
  title: string = '';

  @Input()
  icon: string = '';

  @Input()
  type: 'full-width' | 'container' = 'container';
}
